
import React, { useState } from 'react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Icon } from '@/components/ui/icon'
import type { Canvas } from '@/hooks/useCanvas'

interface CanvasRestoreModalProps {
  isOpen: boolean
  onClose: () => void
  canvas: Canvas | null
  onRestore: (canvasId: string) => Promise<void>
}

export const CanvasRestoreModal: React.FC<CanvasRestoreModalProps> = ({
  isOpen,
  onClose,
  canvas,
  onRestore,
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const handleRestore = async () => {
    if (!canvas) return

    setIsLoading(true)
    try {
      await onRestore(canvas.uuid)
      onClose()
    } catch (error) {
      console.error('Failed to restore canvas:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Restore Session</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to restore &quot;{canvas?.title}&quot; from trash?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={handleRestore}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <Icon name="loader-2" className="mr-2 h-4 w-4 animate-spin" />
                Restoring...
              </>
            ) : (
              'Restore'
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}